import { render, staticRenderFns } from "./BatteryOptions.vue?vue&type=template&id=9971046c&scoped=true"
import script from "./BatteryOptions.vue?vue&type=script&lang=ts"
export * from "./BatteryOptions.vue?vue&type=script&lang=ts"
import style0 from "./BatteryOptions.vue?vue&type=style&index=0&id=9971046c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9971046c",
  null
  
)

export default component.exports